import { CheckboxInput } from '@framework/form/inputs/CheckboxInput.tsx';
import { RichTextAdvancedRender } from '../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender.tsx';
import { ConfigFormItem } from '../../../../../ui/form/ConfigFormItem.tsx';
import { type IWidgetComponentProps } from '../../../IWidgetType.ts';
import { ParagraphSizeText } from '../../common/style/ParagraphSizeText.tsx';
import { hasBlockLabelLayout } from '../common/label-layout/hasBlockLabelLayout.ts';
import { getWidgetProps } from '../common/util/getWidgetProps.ts';
import { type IBooleanWidget } from './IBooleanWidget.ts';

export interface IBooleanWidgetComponentProps
  extends IWidgetComponentProps<IBooleanWidget> {}

export function BooleanWidgetComponent(props: IBooleanWidgetComponentProps) {
  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      name={options.name}
      label={<RichTextAdvancedRender inline text={options.label} />}
      help={
        options?.helpText ? (
          <RichTextAdvancedRender inline text={options?.helpText} />
        ) : undefined
      }
      layout={{
        hideVisualLabel: options?.hideLabel,
        removeLabelSpace: props.widget.layout?.isTableColumn,
        labelLayoutBlock: hasBlockLabelLayout(props.widget),
      }}
      readonly={options.readonly}
      allowsBooleanCheckboxAsterisk
      widget={props.widget}
    >
      <CheckboxInput
        readOnly={props.readonly}
        name={options.name}
        tabIndex={options.preview ? -1 : undefined}
      >
        <ParagraphSizeText>
          <RichTextAdvancedRender hasCustomFont inline text={options.text} />
        </ParagraphSizeText>
      </CheckboxInput>
    </ConfigFormItem>
  );
}
